import Login from './views/Login.vue'
import ForgotPassword from './views/ForgotPassword.vue'
import ChangePassword from './views/ChangePassword.vue'
import ChangeTemporaryPassword from './views/ChangeTemporaryPassword.vue'

export const authRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      auth: false,
      layout: 'login'
    }
  },
  {
    path: '/forgotPassword',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: {
      auth: false,
      layout: 'login'
    }
  },
  {
    path: '/changePassword',
    name: 'ChangePassword',
    component: ChangePassword,
    meta: {
      auth: false,
      layout: 'login'
    }
  },
  {
    path: '/changeTemporaryPassword',
    name: 'ChangeTemporaryPassword',
    component: ChangeTemporaryPassword,
    meta: {
      auth: false,
      layout: 'login'
    }
  }
]
